import { useState } from "react"

// libraries
import { Button } from "@mui/material"

// providers
import { trans } from "@/_providers/Translation"

// images
import removeImage from "@/assets/img/reservations/icons/remove.svg"

export default function StorageStatusAutoCondition({
  act,
  index,
  removeAction,
  reservationActions,
  updateActionField,
  finalStatuses,
}) {
  const [hidden, setHidden] = useState(false)

  return (
    <li key={act.id} className="action-container">
      <div
        className={`action-head ${hidden ? "collapsed" : ""}`}
        onClick={() => {
          setHidden(!hidden)
        }}
      >
        {trans('tables.activity')} {index + 1}
        <Button
          onClick={(e) => {
            e.stopPropagation()
            removeAction(index)
          }}
        >
          <img src={removeImage} alt="Remove" />
        </Button>
      </div>
      {!hidden ? (
        <div className="action-body">
          <div className="row">
            <div className="col">
              <label>{trans('labels.chooseAction')}</label>
              <select
                value={act.reservationStatusId}
                onChange={(e) =>
                  updateActionField(
                    index,
                    "reservationStatusId",
                    e.target.value,
                  )
                }
              >
                {/* <option key="" value="">
                  -
                </option> */}
                {reservationActions.map((action) => (
                  <option key={action.key} value={action.key}>
                    {action.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="col">
              <label>{trans('headings.finalStatus')}</label>
              <span
                style={{
                  backgroundColor:
                    finalStatuses.find(
                      (status) => Number(status.id) === Number(act.reservationStatusId),
                    )?.color || "#000",
                }}
              ></span>
              <select
                value={act.reservationStatusId}
                onChange={(e) =>
                  updateActionField(index, "reservationStatusId", e.target.value)
                }
              >
                <option key="null" value="">
                  -
                </option>
                {finalStatuses.map((status) => (
                  <option key={status.id} value={status.id}>
                    {status.value}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </li>
  )
}
